import { motion } from "framer-motion";
import { Heart } from "lucide-react";

const LOGO_URL = "./img/knots-logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="section-wrapper py-12 sm:py-16 px-4 sm:px-6 bg-[#8B0000]"
      data-testid="footer-section"
    >
      <div className="max-w-4xl mx-auto text-center">
        {/* Thank You Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-6 sm:mb-8"
        >
          <p className="font-serif-accent text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.3em] text-[#D4AF37] uppercase mb-3 sm:mb-4">
            Thank You
          </p>
          <h3 className="font-serif-heading text-xl sm:text-2xl md:text-4xl text-[#FCFAF2] mb-3 sm:mb-4">
            Kevin & Michelle
          </h3>
          <p className="font-sans text-xs sm:text-sm text-[#FCFAF2]/70 max-w-md mx-auto px-4">
            We are deeply honored by your presence and blessings on our special
            day
          </p>
        </motion.div>

        {/* Decorative Divider */}
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="footer-divider bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"
        />

        {/* Double Happiness Symbol */}
        {/* <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="my-6 sm:my-8"
        >
          <span
            className="text-4xl sm:text-5xl text-[#D4AF37]"
            style={{ fontFamily: "serif" }}
          >
            囍
          </span>
        </motion.div> */}

        {/* Logo */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mb-6 sm:mb-8"
        >
          <img
            src={LOGO_URL}
            alt="KNOTS Wedding Organizer"
            className="w-20 sm:w-24 md:w-28 h-auto mx-auto opacity-90"
            style={{
              filter:
                "brightness(0) invert(1) drop-shadow(0 2px 8px rgba(212, 175, 55, 0.3))",
            }}
            data-testid="footer-logo"
          />
        </motion.div> */}

        {/* Built With Love */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="font-sans text-[10px] sm:text-xs text-[#FCFAF2]/50 flex items-center justify-center gap-1 mb-3 sm:mb-4"
        >
          Built by KNOTS Wedding Organizer & Planner
        </motion.p>

        {/* Copyright */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="font-sans text-[10px] sm:text-xs text-[#FCFAF2]/40"
        >
          © {currentYear} All rights reserved
        </motion.p>
      </div>
    </footer>
  );
};

export default Footer;
